// Mapping between HomePage categories and Menu items
export const homepageToMenuMapping = {
  // Appetizers
  'homepage.categories.appetizers.tomatoToast.title': 'menu.items.tomatoToast.name',
  'homepage.categories.appetizers.noodleSoup.title': 'menu.items.noodleSoup.name',
  'homepage.categories.appetizers.pumpkinSoup.title': 'menu.items.pumpkinSoup.name',
  
  // Homestyle Sushi
  'homepage.categories.homestyle.dragonSushi.title': 'menu.items.dragonSushi.name',
  'homepage.categories.homestyle.creamySushi.title': 'menu.items.creamySushi.name',
  'homepage.categories.homestyle.salmonRoll.title': 'menu.items.rollSalmonSushi.name',
  
  // Steak
  'homepage.categories.steak.steakTartare.title': 'menu.items.steakTartare.name',
  'homepage.categories.steak.surfTurf.title': 'menu.items.surfTurf.name',
  'homepage.categories.steak.wagyuBeef.title': 'menu.items.wagyuBeef.name',
  
  // Chicken
  'homepage.categories.chicken.creamyParmesan.title': 'menu.items.creamyParmesan.name',
  'homepage.categories.chicken.springChicken.title': 'menu.items.springChicken.name',
  'homepage.categories.chicken.chickenFrancese.title': 'menu.items.chickenFrancese.name',
  
  // Beverages
  'homepage.categories.beverages.panthouseTonic.title': 'menu.items.panthouseTonic.name',
  'homepage.categories.beverages.appleBreeze.title': 'menu.items.appleBreeze.name',
  'homepage.categories.beverages.frenchmanBlitz.title': 'menu.items.frenchmanBlitz.name',
};

// Price mapping for each item
export const itemPrices = {
  // Appetizers
  'menu.items.tomatoToast.name': 120,
  'menu.items.noodleSoup.name': 90,
  'menu.items.pumpkinSoup.name': 90,
  
  // Homestyle Sushi
  'menu.items.dragonSushi.name': 480,
  'menu.items.creamySushi.name': 250,
  'menu.items.rollSalmonSushi.name': 360,
  
  // Steak
  'menu.items.steakTartare.name': 850,
  'menu.items.surfTurf.name': 700,
  'menu.items.wagyuBeef.name': 950,
  
  // Chicken
  'menu.items.creamyParmesan.name': 260,
  'menu.items.springChicken.name': 300,
  'menu.items.chickenFrancese.name': 400,
  
  // Beverages
  'menu.items.panthouseTonic.name': 70,
  'menu.items.appleBreeze.name': 70,
  'menu.items.frenchmanBlitz.name': 70,
};

// Function to get menu item key from homepage title key
export function getMenuItemKey(homepageTitleKey) {
  return homepageToMenuMapping[homepageTitleKey];
}

// Function to get price for a menu item
export function getItemPrice(menuItemKey) {
  return itemPrices[menuItemKey];
}

// Function to create a cart item from homepage data
export function createCartItem(homepageTitleKey, i18n) {
  const menuItemKey = getMenuItemKey(homepageTitleKey);
  if (!menuItemKey) {
    console.warn(`No mapping found for homepage title key: ${homepageTitleKey}`);
    return null;
  }
  
  const price = getItemPrice(menuItemKey);
  if (price === undefined) {
    console.warn(`No price found for menu item: ${menuItemKey}`);
    return null;
  }
  
  return {
    name: i18n.t(menuItemKey),
    price: price,
    quantity: 1,
    specialRequest: "",
    showSpecialRequest: false,
  };
} 